import React, { ReactNode } from 'react';

import { Button } from '@infoods/lifebase-ui';
import { observer } from 'mobx-react';

import { ErrorState } from '../../components/ErrorState/ErrorState';
import { loggedInUserDataStore } from '../../stores/loggedInUserDataStore';
import { logout } from '../../utils/userInfoUtils/logout/logout';

type UnavailableWhenLoggedInProps = {
  children: ReactNode;
};

const UnavailableWhenLoggedIn = observer(({ children }: UnavailableWhenLoggedInProps) => {
  const { loggedInUser } = loggedInUserDataStore;

  if (!loggedInUser) {
    return children;
  }

  return (
    <ErrorState
      title="Customer registration form is unavailable while you're logged in"
      description={
        <p>
          To fix this, click the Log out button below.
          <br />
          Once you log out, the customer registration form will become available.
        </p>
      }
    >
      <Button variant="contained" onClick={() => logout(null)}>
        Log Out
      </Button>
    </ErrorState>
  );
});

export { UnavailableWhenLoggedIn };
